import spinner from '../templates/spinner.hbs';

class SinclairSpinner extends HTMLElement {
    constructor(){
        super();
        const {size = 250} = this.dataset;

        this.innerHTML = spinner({size});
    }
}

customElements.define('sinclair-spinner', SinclairSpinner);
